import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Crawlable internal links to the SEO hubs (journals & rubrics), discreet footer.
export const SeoFooter = () => {
  const [nav, setNav] = useState(null);
  useEffect(() => { axios.get(`${API}/seo/nav`).then((r) => setNav(r.data)).catch(() => {}); }, []);
  if (!nav) return null;
  const base = process.env.REACT_APP_BACKEND_URL;
  return (
    <footer className="mt-12 border-t border-border px-4 sm:px-6 lg:px-8 py-8 text-xs text-muted-foreground" data-testid="seo-footer">
      <div className="max-w-7xl mx-auto space-y-4">
        <p className="font-semibold text-foreground">
          <a href={`${base}/api/seo/kiosque`} data-testid="seo-footer-all" className="hover:text-primary">Tous les journaux et magazines en PDF</a>
        </p>
        <nav aria-label="Rubriques" className="flex flex-wrap gap-x-3 gap-y-1">
          {nav.categories.map((c) => (
            <a key={c.slug} href={`${base}/api/seo/categorie/${c.slug}`} className="hover:text-primary">Presse {c.name}</a>
          ))}
        </nav>
        <nav aria-label="Journaux" className="flex flex-wrap gap-x-3 gap-y-1">
          {nav.journals.map((j) => (
            <a key={j.slug} href={`${base}/api/seo/journal/${j.slug}`} className="hover:text-primary">Lire {j.name}</a>
          ))}
        </nav>
        <p>© APP PRESSE — le kiosque numérique de la presse française</p>
      </div>
    </footer>
  );
};
